import React, { useEffect }  from 'react';

import {  Link, useHistory } from "react-router-dom";
import moment from "moment";

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import Typography from '@material-ui/core/Typography'
import MaterialTable from 'material-table'
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'


//service
import DatasetDynamicService from '../../services/DatasetDynamicService'
import CompanyService from '../../services/CompanyService'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop:20,
  },
  paper: {
    padding: theme.spacing(2),    
    color: theme.palette.text.secondary,
    display: 'flex',
  },
  dataTableStyel: {
    fontSize:10,
  },
  chip: {
    display: 'flex',    
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));

export default (props) => {
  
  const classes = useStyles();
  const history = useHistory()
  const [data, setData] = React.useState([])
  const [companiesSelected, setCompaniesSelected] = React.useState({id:'', label:''})
  const [companies, setCompanies] = React.useState([])
  
  const handleAddNew = () => {
    history.push(`/dataset/add`)      
  }

  const handleButtonClick = (row) => {          
    history.push(`/dataset/add/${row.id}`)      
  }

  const handleDelete = (row) => {       
    if (window.confirm(`Tem certeza que deseja excluir:\r ${row.description}?`)) {
    const response = DatasetDynamicService.deleteById(row.id)
    response
      .then(resp => {
        loadingAll()
      })
      .catch(error => console.error(error))
    }
  }

  const loadingAll = (item) => {    
    let params = {}      
    if(item){
      params = {
        company: item.id
      }
    }
    
    setData([])
    const response = DatasetDynamicService.search(params)
    response.then(resp => {
      setData(resp.data)      
    })
  }

  const handleCompanySelectItem = (option, param) => {       
    setCompaniesSelected(param)     
    loadingAll(param)   
  }

  const handleCompany = (event) => {                  
    searchCompanyByTerm(event.target.value.trim())  
  }

  const handleSearchCompanyDefault = () => {                  
    searchCompanyByTerm('ads')  
  }

  const searchCompanyByTerm = (term) => {    

    if(!term || term.length < 2) return 

    // setLoadingCompany(true)
    const companiesResponse = CompanyService.companies(term)
    companiesResponse
      .then(resp => {  
        setCompanies(resp.data)                      
        // setLoadingCompany(false)
      })
      .catch(err => {
        // setLoadingCompany(false)
        console.error(err)
      })    
  }

  useEffect(() => {      
    loadingAll()
  }, [])

  return(
    <Grid container spacing={2}>
      <Grid item xs={12} >
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/"  >
              <Home/>
            </Link>            
            <Typography color="textPrimary">Datasets</Typography>
          </Breadcrumbs>
        </Grid>  

        <Grid container spacing={3}>
          <Grid item xs={12}>

            <Paper className={classes.paper}>

              
                  <Grid item xs={4}  md={6} >
                      <IconButton color="primary" onClick={handleAddNew} ><AddCircleIcon /></IconButton>   
                  </Grid>

                  <Grid item xs={8} md={6} >
                    <Autocomplete     
                      value={companiesSelected}                     
                      onChange={handleCompanySelectItem}   
                      onKeyUp={handleCompany}
                      filterSelectedOptions                
                      options={companies}        
                      getOptionLabel={(option) => {                                    
                        return option.id +" - " + option.label;
                      }}       
                      getOptionSelected={(option, value) => option.label === value.label}    
                      renderOption={(option) => {                                    
                        return `${option.id} | ${option.label} | ${option.identifier ? `cnpj ${option.identifier}`:''}`
                      }}   
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip                                  
                              color="primary" 
                              label={option.id + ' ' + option.label} 
                              {...getTagProps({ index })} 
                              />
                        ))
                      } 
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onClick={handleSearchCompanyDefault}
                          variant="standard"
                          label="Empresas"
                          placeholder="Selecione"
                        />
                      )}
                  />
                </Grid>


            </Paper>
          </Grid>
          <Grid item xs={12}>            
                <MaterialTable
                  className={classes.dataTableStyel}
                  title="Datasets"
                  allowfullscreen
                  columns={[
                    {
                      title: 'Descrição',
                      field: 'description',
                      width: 300,                      
                    },    
                    {
                      title: 'Cadastro',
                      field: 'register',   
                      render: row => moment(row.register).format('DD/MM/YYYY'),
                    },                                         
                    {
                      title: 'Dashboard',
                      field: 'isShowDashboard',   
                      width: 50,
                      align: 'center',
                      render: row => row.isShowDashboard?<Chip size="small" color="primary" label="Sim" />:<Chip size="small" color="secondary" label="Não" />,
                    }, 
                    {
                      title: 'Menu',
                      field: 'isShowMenu',   
                      width: 50,
                      align: 'center',
                      render: row => row.isShowMenu?<Chip size="small" color="primary" label="Sim" />:<Chip size="small" color="secondary" label="Não" />,
                    }, 
                    {
                      title: 'Ativo',
                      field: 'enable',   
                      width: 50,
                      align: 'center',
                      render: row => row.enable?<Chip size="small" color="primary" label="Sim" />:<Chip size="small" color="secondary" label="Não" />,
                    },
                    {
                      title: 'Cache',
                      field: 'isUseCache',   
                      width: 50,
                      align: 'center',
                      render: row => row.isUseCache?<Chip size="small" color="primary" label="Sim" />:<Chip size="small" color="secondary" label="Não" />,
                    },    
                    {
                      title: 'Ordem',
                      field: 'order',                         
                      width: 50,
                      align: 'center',
                    }, 
                    {
                      title: 'Empresa(s)',
                      field: 'companies',                                             
                      render: row => row.companies.map((c, i) => <div key={i} className={classes.chip} ><Chip size="small" color="primary" label={c.label} /></div>),                      
                    },
                    {
                      title: 'Usuário(s)',
                      field: 'users', 
                      render: row => row.users.map((c, i) => <div key={i} className={classes.chip} ><Chip size="small" color="primary" label={c.label} /></div>),
                    },  
                    {
                      title: 'Largura',
                      field: 'spaceWidth',                       
                      width: 50,
                      align: 'center',
                    }, 
                    {
                      title: 'Altura',
                      field: 'spaceHeight',    
                      width: 50,    
                      align: 'center',               
                    }, 
                     
                                                       
                  ]}
                  data={data}        
                  options={{
                    search: true,
                    pageSize: 20,
                    pageSizeOptions: [5, 10, 20, 30 ,50, 75, 100 ],
                  }}
                  actions={[
                    {
                      icon: 'edit',
                      tooltip: 'Editar Dataset',
                      onClick: (event, row) => handleButtonClick(row),
                    },
                    {
                      icon: 'delete',
                      tooltip: 'Excluir Dataset',
                      onClick: (event, row) => handleDelete(row),
                    },                    
                  ]}

                />
          </Grid>             
        </Grid>

    </Grid>      
  )

}